/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_TitleInputs */



/**
* | output |
* | --- |
* | "Loudness Normalization" |
*
* @param {Audio_Description_Export_Loudness_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_title = /** @type {((inputs?: Audio_Description_Export_Loudness_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Normalisation du niveau sonore")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautstärkenormalisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Normalizzazione del volume")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нормализация громкости")
	if (locale === "es") return /** @type {LocalizedString} */ ("Normalización de sonoridad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("响度标准化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラウドネス正規化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ध्वनि सामान्यीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Normalização de intensidade sonora")
	return /** @type {LocalizedString} */ ("Loudness Normalization")
});